module.exports = __webpack_public_path__ + "static/media/Client_Logos.0dda31be.png";